var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperativeNoteWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6759 10.5003L8.00925 2.33363C7.90749 2.15408 7.75993 2.00474 7.58162 1.90083C7.40331 1.79693 7.20062 1.74219 6.99425 1.74219C6.78787 1.74219 6.58519 1.79693 6.40688 1.90083C6.22856 2.00474 6.081 2.15408 5.97925 2.33363L1.31258 10.5003C1.20973 10.6784 1.1558 10.8806 1.15625 11.0863C1.15671 11.2919 1.21153 11.4939 1.31517 11.6715C1.41881 11.8492 1.56758 11.9963 1.7464 12.0979C1.92522 12.1996 2.12774 12.2521 2.33341 12.2503H11.6667C11.8714 12.2501 12.0725 12.196 12.2497 12.0935C12.4269 11.9911 12.574 11.8438 12.6762 11.6664C12.7785 11.4891 12.8323 11.288 12.8322 11.0833C12.8322 10.8786 12.7783 10.6776 12.6759 10.5003Z",
    stroke: "#FE9A00",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.25V7.58333",
    stroke: "#FE9A00",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.91406H7.00583",
    stroke: "#FE9A00",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperativeNoteWarning);
export default __webpack_public_path__ + "static/media/OperativeNoteWarning.dac5e5b8c245e10abb1e0270716c3d48.svg";
export { ForwardRef as ReactComponent };